{
  "menu": {
    "about": "À Propos",
    "facilities": "Installations",
    "villas": "Villas & Tarifs",
    "allRooms": "Toutes les Chambres",
    "experiences": "Activités",
    "gallery": "Galerie",
    "news": "Actualités",
    "contact": "Contact",
    "dining": "Dîner",
    "spa": "Spa"
  },
  "cta": {
    "book": "Réserver",
    "contact": "Contactez-nous",
    "back_to_home": "Retour à l'Accueil",
    "read_more": "Lire la Suite"
  },
  "home": {
    "culture": {
      "subtitle": "Authentique Héritage Balinais",
      "title": "Expériences Culturelles",
      "desc": "Plongez dans le riche héritage spirituel et culturel de Bali. Des rituels sacrés de purification de l'eau à l'exploration des traditions anciennes, nous vous guidons dans un voyage à la découverte de la véritable âme de l'île.",
      "journeySub": "Voyage Spirituel",
      "journeyTitle": "Purification à Sidemen",
      "journeyDesc": "Découvrez un rituel traditionnel balinais de purification de l'eau (Melukat) dans les sources sacrées de Sidemen, conçu pour purifier votre corps, votre esprit et votre âme.",
      "btnReserve": "Réservation"
    },
    "activities": {
      "subtitle": "Moments Précieux",
      "title": "Choses à Faire",
      "desc": "Nous proposons les meilleures activités sélectionnées pour créer des souvenirs inoubliables pendant votre séjour. Plongez dans la magie de Bali, des aventures palpitantes aux explorations culturelles profondes et au bien-être spirituel.",
      "btnView": "Voir les Activités",
      "btnReserve": "Réservation"
    },
    "different": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Ce Qui Nous Différencie",
      "desc": "Découvrez la véritable essence d'un joyau caché. Loin des foules, nous offrons un sanctuaire isolé où chaque détail est conçu pour vous aider à vous déconnecter, vous ressourcer et repartir avec de beaux souvenirs qui durent toute une vie.",
      "card1": {
        "sub": "Un sanctuaire privé loin du monde",
        "title": "Le Joyau Caché de Sidemen",
        "desc": "Niché à l'écart des rues animées, notre villa offre l'exclusivité et l'intimité ultimes. Ici, vous n'êtes pas seulement un invité, mais un voyageur privilégié découvrant la sérénité intacte de l'authentique Bali."
      },
      "card2": {
        "sub": "Éveillez vos sens et ressourcez votre âme",
        "title": "Énergie Renouvelée",
        "desc": "Respirez l'air frais de nos luxuriants jardins tropicaux et de nos vastes rizières. Chaque moment passé dans notre cadre paisible est conçu pour rajeunir votre esprit, votre corps et votre âme."
      },
      "card3": {
        "sub": "Des moments que vous chérirez pour toujours",
        "title": "Beaux Souvenirs",
        "desc": "Des sourires sincères aux expériences locales authentiques, nous concevons chaque détail de votre séjour avec un soin sincère. Rentrez chez vous non seulement reposé, mais avec de belles histoires inoubliables à raconter."
      }
    },
    "booking": {
      "title": "Prêt à Découvrir Patal Kikian ?",
      "desc": "Vérifiez la disponibilité et sécurisez votre sanctuaire privé dès aujourd'hui."
    },
    "contact": {
      "subtitle": "Contact",
      "title": "Comment nous joindre",
      "desc": "Que vous ayez une question sur nos chambres, que vous ayez besoin d'aide pour votre réservation ou que vous ayez une demande spéciale pour votre prochain séjour, notre équipe de conciergerie dévouée est là pour vous aider.",
      "btnEmail": "Envoyer un Email",
      "btnWa": "Contactez-nous sur WhatsApp"
    },
    "hero": {
      "subtitle": "Bienvenue aux Villas Patal Kikian",
      "title": "Éveillez-vous au Panorama le Plus Époustouflant de Bali",
      "description": "Embrassez la présence majestueuse du mont Agung qui veille sur les rizières en terrasses émeraude et les vallées verdoyantes. Ici, dans la douce étreinte de Sidemen, l'air pur des montagnes et la sérénité intacte se mêlent pour créer un sanctuaire inoubliable pour votre âme."
    },
    "intro": {
      "quote": "\"Pendant des décennies, la beauté captivante de Sidemen a inspiré le monde.\"",
      "p1": "En 1938, l'artiste légendaire Walter Spies a immortalisé le charme enchanteur de cette région à travers son chef-d'œuvre, <span className=\"italic text-white\">\"Morning in Iseh.\"</span> La peinture capturait à merveille la majesté imposante du mont Agung, les rizières émeraude luxuriantes, la douce brume matinale et le rythme paisible de la vie rurale balinesa. À ce jour, cela reste un symbole emblématique de la splendeur naturelle de Bali.",
      "p2": "Aujourd'hui, ce même panorama à couper le souffle se déploie sous vos yeux aux Villas Patal Kikian.",
      "p3": "Chaque matin apporte un lever de soleil spectaculaire qui baigne le mont Agung d'une lumière dorée, illuminant les vastes vallées verdoyantes et apportant une brise fraîche de la montagne. Ici, la tranquillité règne, donnant l'impression que le temps s'est arrêté.",
      "p4": "Au Patal Kikian, vous ne séjournez pas seulement dans une villa de luxe ; vous vous immergez dans le paysage même qui a captivé les artistes, les photographes et les amoureux de la nature des quatre coins du globe.",
      "p5": "Nous offrons une harmonie parfaite entre un luxe raffiné, un riche héritage culturel et la beauté naturelle authentique de Sidemen.",
      "footerQuote": "Arrivez pour des vacances. Repartez avec des souvenirs dont vous vous languirez à jamais.",
      "footerBrand": "Villas Patal Kikian",
      "footerTagline": "Où Chaque Lever de Soleil Devient un Chef-d'œuvre"
    },
    "restaurant": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Restaurant Patal Kikian",
      "desc": "Situé à côté de notre piscine à débordement et de notre élégant bar, notre restaurant offre une expérience culinaire remarquable encadrée par une vue imprenable sur les vallées verdoyantes et les vastes rizières. Savourez des créations culinaires exquises tandis que la douce brise et le cadre naturel à couper le souffle éveillent vos sens.",
      "callToAction": "Explorez nos offres culinaires exquises. Découvrez nos spécialités locales et internationales en consultant notre menu, ou réservez votre table pour une expérience gastronomique inoubliable.",
      "btnMenu": "Voir le Menu",
      "btnReserve": "Réservation",
      "btnTransport": "Réservation Transport Spécial",
      "btnTransportSub": "(Région de Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Localisation"
    },
    "spa": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Spa Patal Kikian",
      "desc": "Rajeunissez votre esprit, votre corps et votre âme au Spa Patal Kikian. Découvrez d'authentiques rituels de guérison balinais et des massages relaxants prodigués par nos thérapeutes qualifiés, tout en admirant la beauté naturelle époustouflante de Sidemen.",
      "callToAction": "Découvrez notre gamme complète de soins holistiques. Consultez notre menu de spa pour explorer nos thérapies relaxantes, ou réservez votre session de rajeunissement dès aujourd'hui.",
      "btnMenu": "Voir le Menu",
      "btnReserve": "Réservation",
      "btnTransport": "Réservation Transport Spécial",
      "btnTransportSub": "(Région de Sidemen)",
      "btnMaps": "Google Maps",
      "btnMapsSub": "Localisation"
    },
    "rooms": {
      "subtitle": "Patal Kikian Sidemen",
      "title": "Villas Patal Kikian",
      "desc": "Chaque villa est soigneusement conçue comme votre sanctuaire privé, offrant des vues imprenables et ininterrompues sur le mont Agung, les vastes rizières et les vallées verdoyantes, mêlant harmonieusement le luxe à la sérénité de la nature."
    }
  },
  "about": {
    "hero": {
      "subtitle": "Notre Histoire",
      "title": "Éveillez-vous au panorama le plus époustouflant de Bali",
      "desc": "Embrassez la majesté du mont Agung qui veille sur les rizières en terrasses et les vallées verdoyantes. Ici, dans la douce étreinte de Sidemen, l'air pur des montagnes et la sérénité intacte se mêlent pour créer un sanctuaire inoubliable pour votre âme.",
      "btnScroll": "Lire l'Histoire"
    },
    "story": {
      "p1": "Niché à la périphérie de Sidemen, Karangasem, Patal Kikian Villas est plus qu'une simple destination ; c'est une invitation à découvrir le cœur battant de Bali. Avec des vues panoramiques depuis le sommet de la colline, chaque matin commence ici par une symphonie de la nature : un lever de soleil doré illuminant le sommet du mont Agung, encadré d'une verdure sans fin et de paysages immaculés.",
      "p2": "Nous croyons que le vrai luxe réside dans l'harmonie avec la nature. En entrant dans notre sanctuaire, vous êtes enveloppé par l'air frais et pur de la montagne et par un profond sentiment de tranquillité. C'est un lieu conçu pour vous déconnecter du bruit du monde et vous reconnecter avec l'essentiel.",
      "subtitle": "Une harmonie entre nature et culture",
      "p3": "Nos villas reflètent un mélange harmonieux d'architecture balinaise traditionnelle et de confort moderne, soigneusement conçu pour honorer la riche culture de Sidemen. Nous sommes fiers de notre hospitalité chaleureuse et authentique. Ici, chaque sourire est sincère, et chaque service est fourni avec le plus grand respect pour nos hôtes et notre patrimoine local.",
      "quote": "\"Patal Kikian Villas est votre paradis caché : un lieu où des paysages majestueux, une culture riche et une hospitalité chaleureuse tissent une inoubliable toile de souvenirs.\"",
      "footer": "Nous avons hâte de vous accueillir dans notre sanctuaire."
    }
  },
  "facilities": {
    "hero": {
      "subtitle": "Commodités du Complexe",
      "title": "Nos Installations",
      "desc": "Découvrez nos installations haut de gamme conçues pour vous offrir confort et détente tout au long de votre séjour à Sidemen.",
      "btnScroll": "Voir les Installations"
    },
    "fallback": {
      "poolSub": "Oasis de Sérénité",
      "poolTitle": "Piscines",
      "poolDesc1": "Plongez dans nos piscines à débordement cristallines surplombant les jardins tropicaux luxuriants et la vallée. Que vous profitiez d'une baignade matinale, d'un petit-déjeuner flottant, ou simplement d'un moment de détente au soleil avec un cocktail rafraîchissant, nos piscines offrent l'espace ultime pour la relaxation.",
      "poolDesc2": "Des bassins profonds privés sont également disponibles dans certaines villas pour ceux qui recherchent une retraite intime.",
      "restSub": "Excellence Culinaire",
      "restTitle": "Restaurant",
      "restDesc1": "Laissez-vous tenter par un voyage gastronomique dans notre restaurant signature en plein air. Nous sommes fiers de servir une cuisine balinaise authentique aux côtés de plats internationaux, le tout préparé à partir d'ingrédients biologiques frais d'origine locale.",
      "restDesc2": "Profitez de votre petit-déjeuner gratuit, de dîners romantiques aux chandelles ou d'afternoon teas décontractés tout en admirant la vue imprenable sur la nature environnante.",
      "restBtn": "Voir Plus",
      "spaSub": "Bien-être et Guérison",
      "spaTitle": "Spa de Luxe",
      "spaDesc1": "Rajeunissez votre esprit, votre corps et votre âme dans notre paisible sanctuaire de spa. Ancrés dans les anciennes traditions de guérison balinaises, nos thérapeutes professionnels proposent une gamme de soins allant des massages traditionnels aux gommages corporels et soins du visage revitalisants.",
      "spaDesc2": "En tant que notre invité, vous recevrez également un massage gratuit des pieds de 15 minutes à votre arrivée pour faire disparaître instantanément votre fatigue de voyage.",
      "spaBtn": "Voir Plus"
    }
  },
  "accommodation": {
    "hero": {
      "subtitle": "Nos Chambres",
      "title": "Sanctuaires de Sérénité aux Patal Kikian Villas",
      "desc": "Faites l'expérience de la tranquillité ultime dans nos villas conçues avec soin, alliant confort moderne et authenticité balinaise.",
      "btnScroll": "Explorer les Chambres"
    },
    "detail": {
      "loading": "Chargement des détails de la chambre...",
      "signature": "Chambre Signature",
      "gallerySub": "Galerie",
      "galleryTitle": "Galerie de Photos",
      "noImages": "Aucune image disponible pour ce type de chambre.",
      "aboutRoom": "À propos de la chambre",
      "roomSize": "Taille de la chambre",
      "bedSize": "Taille du lit",
      "view": "Vue",
      "amenities": "Commodités",
      "inclusions": "Inclusions",
      "pleaseNote": "Veuillez noter",
      "roomRules": "Règles et informations",
      "roomPolicy": "Politique de la chambre",
      "childrenPolicies": "Politiques relatives aux enfants",
      "childrenPolicyDesc": "Les enfants de tout âge sont autorisés. Les enfants jusqu'à 5 ans inclus peuvent séjourner gratuitement. Les enfants de 6 à 12 ans peuvent séjourner pour 151.250,00 IDR par enfant et par nuit avec un lit d'appoint.",
      "babyCot": "Lit bébé",
      "babyCotDesc": "Les enfants jusqu'à 2 ans inclus séjournent gratuitement s'ils utilisent un lit bébé disponible.",
      "extraBed": "Lit d'appoint",
      "extraBedDesc": "Les personnes, quel que soit leur âge, séjournent pour 302.500,00 IDR par personne et par nuit lorsqu'elles utilisent un lit d'appoint disponible.",
      "noSmoking": "Il est interdit de fumer.",
      "noPets": "Les animaux de compagnie ne sont pas autorisés.",
      "reserve": "Réserver",
      "directBooking": "Réservation directe avec nous",
      "bookOnBooking": "Réserver sur Booking.com",
      "contactConcierge": "Contactez notre conciergerie pour toute question de réservation et demande personnalisée.",
      "otherChoices": "Autres choix",
      "otherRooms": "Autres chambres qui pourraient vous plaire",
      "bookYourStay": "Réservez votre séjour"
    }
  },
  "luxuryCard": {
    "discover": "Découvrir"
  },
  "rooms": {
    "deluxe-bungalow-mountain-view": {
      "title": "Bungalow de Luxe (Vue Montagne)",
      "description": "Ce bungalow dispose d'une piscine à débordement. Doté d'une entrée privée, ce bungalow climatisé se compose d'un salon, d'une chambre séparée et d'une salle de bains avec douche et sèche-cheveux. Le bungalow est meublé d'un bureau, d'un coin salon, d'un minibar, d'une cafetière/théière et offre une vue sur le jardin. L'unité offre 1 lit.",
      "view": "Vue sur Jardin, Piscine, Montagne, Point de repère et Rivière",
      "roomRules": "Fumeur: Non fumeur. Heures calmes après 22h. Arrivée à 14h, Départ à 12h."
    },
    "suite-room-mountain-view": {
      "title": "Suite (Vue Montagne)",
      "description": "Les clients vivront une expérience spéciale car cette suite offre une piscine avec vue. Dotée d'une entrée privée, cette suite spacieuse se compose également d'une chambre, d'un coin salon et d'une salle de bains avec douche et sèche-cheveux. L'unité dispose de la climatisation, d'une vue sur le jardin, d'une terrasse et de vin/champagne offert aux clients. L'unité offre 1 lit.",
      "view": "Vue sur Montagne, Rivière, Point de repère, Piscine et Jardin",
      "roomRules": "Fumeur: Non fumeur. Heures calmes après 22h. Arrivée à 14h, Départ à 12h."
    },
    "private-pool-villa-mountain-view": {
      "title": "Villa avec Piscine Privée (Vue Montagne)",
      "description": "Cette villa dispose d'une piscine avec vue. Dotée d'une entrée privée, cette villa climatisée se compose d'un salon, d'une chambre séparée et d'une salle de bains avec baignoire et douche. La villa spacieuse dispose d'un minibar, d'une cafetière/théière, d'un coin salon ainsi que d'une terrasse avec vue sur le jardin. L'unité offre 1 lit.",
      "view": "Vue sur Jardin, Piscine, Montagne et Rivière",
      "roomRules": "Fumeur: Non fumeur. Heures calmes après 22h. Arrivée à 14h, Départ à 12h."
    },
    "features": {
      "Infinity Pool": "Piscine à débordement",
      "Mountain View": "Vue sur la Montagne",
      "Private Balcony": "Balcon Privé",
      "Private Pool": "Piscine Privée",
      "Mount Agung View": "Vue sur le Mont Agung",
      "Living Room": "Salon",
      "Nature View": "Vue sur la Nature",
      "Bedroom": "Chambre"
    }
  },
  "experiences": {
    "hero": {
      "subtitle": "Activités",
      "title": "Créez Vos Meilleurs Souvenirs à Bali",
      "desc": "Des aventures nature époustouflantes aux expériences culturelles immersives, nous vous présentons une sélection d'activités pour rendre chaque moment de vos vacances encore plus spécial.",
      "btnScroll": "Voir les Activités"
    },
    "sidebar": {
      "categories": "Catégories",
      "moreActivities": "Plus d'activités"
    },
    "categories": {
      "Adventure & Nature": "Aventure et Nature",
      "Culture & Art": "Culture et Art",
      "Wellness & Spiritual": "Bien-être et Spiritualité"
    },
    "items": {
      "ATV Adventure": {
        "title": "Aventure en Quad",
        "description": "Vivez le frisson de conduire un quad à travers les magnifiques paysages de Bali."
      },
      "Cycling Tour": {
        "title": "Tour à Vélo",
        "description": "Pédalez à travers des rizières verdoyantes et des villages traditionnels lors d'une visite guidée."
      },
      "Rice Terrace Walking Tour": {
        "title": "Promenade dans les Rizières",
        "description": "Faites une promenade paisible à travers certaines des rizières en terrasses les plus emblématiques du monde."
      },
      "Sunrise Jeep Mount Batur": {
        "title": "Lever de Soleil en Jeep au Mont Batur",
        "description": "Assistez à un lever de soleil à couper le souffle depuis le mont Batur sans la randonnée matinale."
      },
      "Scooter Tour": {
        "title": "Tour en Scooter",
        "description": "Explorez les joyaux cachés de Sidemen lors d'une visite guidée passionnante en scooter."
      },
      "Rafting": {
        "title": "Rafting",
        "description": "Vivez la montée d'adrénaline du rafting en eaux vives sur la rivière Ayung."
      },
      "Batur Trekking": {
        "title": "Randonnée au Mont Batur",
        "description": "Faites une randonnée sur le volcan actif du mont Batur et regardez le lever du soleil depuis le sommet."
      },
      "Waterfall Tour": {
        "title": "Excursion aux Cascades",
        "description": "Visitez certaines des cascades les plus étonnantes et cachées de la région de Sidemen."
      },
      "Swing": {
        "title": "Balançoire",
        "description": "Vivez l'adrénaline de vous balancer très haut au-dessus des superbes vallées et jungles de Bali."
      },
      "Mount Agung Trekking": {
        "title": "Randonnée au Mont Agung",
        "description": "Relevez le défi d'une randonnée gratifiante au lever du soleil jusqu'au plus haut sommet de Bali, le mont Agung."
      },
      "Cooking Class": {
        "title": "Cours de Cuisine",
        "description": "Apprenez les secrets de la cuisine balinaise authentique avec nos chefs locaux experts."
      },
      "Silver Class": {
        "title": "Atelier d'Argent",
        "description": "Créez vos propres bijoux en argent uniques guidés par des orfèvres traditionnels."
      },
      "Coffee Plantation Tour": {
        "title": "Visite de Plantation de Café",
        "description": "Découvrez le processus de fabrication du café balinais traditionnel, y compris le célèbre café Luwak."
      },
      "Yoga & Wellness": {
        "title": "Yoga et Bien-être",
        "description": "Rajeunissez votre esprit et votre corps avec nos séances guidées de yoga et de bien-être."
      }
    }
  },
  "restaurant": {
    "items": {
      "Vegetable Spring Roll": {
        "name": "Rouleau de Printemps aux Légumes",
        "description": "Rouleau de printemps aux légumes frit servi avec une sauce au piment doux"
      },
      "Bruschetta": {
        "name": "Bruschetta",
        "description": "Tranche de baguette croustillante, salsa de tomates, oignon, basilic et parmesan"
      },
      "Garlic Cheese Bread": {
        "name": "Pain à l'Ail et au Fromage",
        "description": "Tranche de baguette croustillante avec du fromage mozzarella"
      },
      "Onion Soup": {
        "name": "Soupe à l'Oignon",
        "description": "Soupe à l'oignon caramélisée servie avec du pain à l'ail et au fromage"
      }
    },
    "categories": {
      "Appetizers": "Entrées",
      "Soup": "Soupes",
      "Pasta": "Pâtes",
      "Main Course": "Plats Principaux",
      "Indonesian Food": "Cuisine Indonésienne",
      "Dessert": "Desserts",
      "Beverages": "Boissons"
    },
    "hero": {
      "subtitle": "Restaurant Forêt de Feuilles",
      "title": "Un Voyage Culinaire Apaisant",
      "desc": "Laissez-vous tenter par des créations culinaires exquises qui nourrissent le corps, accompagnées du panorama majestueux du mont Agung et des vallées verdoyantes de Sidemen...",
      "btnScroll": "Voir le Menu"
    },
    "sidebar": {
      "categories": "Catégories",
      "moreCategories": "Plus de Catégories"
    },
    "backToHome": "Retour à l'accueil"
  },
  "spa": {
    "items": {
      "Balinese Massage": {
        "name": "Massage Balinais",
        "description": "Massage traditionnel authentique combiné à une technique balinaise, étirements, pétrissage de la peau et pressions."
      },
      "Frequent Flyer Massage": {
        "name": "Massage Grand Voyageur",
        "description": "Le remède parfait après un long vol pour soulager les tensions. Massage de la tête, du cou et des épaules."
      },
      "Therapeutic Sport Massage": {
        "name": "Massage Sportif Thérapeutique",
        "description": "Idéal pour stimuler la circulation, aider à la guérison des blessures et créer une profonde relaxation."
      },
      "Durma Healthy Massage": {
        "name": "Massage Santé Durma",
        "description": "Expérience ultime commençant par un bain de pieds balinais suivi d'un massage aux mouvements de doigts dansants."
      },
      "Aromatherapy Massage": {
        "name": "Massage Aromathérapie",
        "description": "Massage relaxant utilisant des huiles essentielles extraites d'herbes et de plantes."
      },
      "Patal kikian Stone Massage": {
        "name": "Massage aux Pierres Patal Kikian",
        "description": "Thérapie par la nature utilisant des pierres de rivière chaudes pour détendre les muscles et soulager la douleur."
      },
      "Massage Reflexology": {
        "name": "Réflexologie",
        "description": "Art de guérison chinois ancien axé sur les points de pression des pieds."
      },
      "Flower Bath": {
        "name": "Bain de Fleurs",
        "description": "Pratique de guérison pour éliminer les obstacles émotionnels et améliorer votre aura avec la vitalité naturelle des fleurs."
      },
      "Nail Gel Polish": {
        "name": "Vernis à Ongles en Gel",
        "description": "Vernis à ongles durci avec une lampe UV pour créer une manucure ou pédicure brillante et durable."
      },
      "Foot Massage": {
        "name": "Massage des Pieds",
        "description": "Massage concentré principalement sur les muscles des pieds pour soulager les tensions."
      },
      "Boreh Scrub & Mask": {
        "name": "Gommage et Masque Boreh",
        "description": "Mélange traditionnel à base de plantes qui polit en douceur, nourrit, revitalise et donne de l'éclat à la peau."
      },
      "Chocolate Scrub & Mask": {
        "name": "Gommage et Masque au Chocolat",
        "description": "Gommage hydratant aux extraits de cacao pour éliminer les impuretés et exfolier la peau."
      },
      "Coconut Scrub & Mask": {
        "name": "Gommage et Masque à la Noix de Coco",
        "description": "Soins à la noix de coco pour une hydratation profonde."
      },
      "Refresh Facial": {
        "name": "Soin du Visage Rafraîchissant",
        "description": "Soin rapide pour nettoyer, exfolier et hydrater la peau, idéal pour un coup d'éclat."
      },
      "Traditional Facial": {
        "name": "Soin du Visage Traditionnel",
        "description": "Soin du visage complet avec des ingrédients traditionnels balinais pour une peau éclatante et saine."
      },
      "Spa Manicure": {
        "name": "Manucure Spa",
        "description": "Soin complet des mains, comprenant le façonnage des ongles, le soin des cuticules et l'hydratation."
      },
      "Spa Pedicure": {
        "name": "Pédicure Spa",
        "description": "Soin relaxant pour les pieds, comprenant gommage, massage et soin des ongles."
      },
      "Queen of Kikian": {
        "name": "Reine de Kikian",
        "description": "Le summum du soin spa, combinant massage balinais, gommage, soin du visage et bain de fleurs."
      },
      "Breeze of Sidemen": {
        "name": "Brise de Sidemen",
        "description": "Détente profonde avec massage aromathérapie et bain relaxant."
      },
      "A Taste of Heaven": {
        "name": "Un Goût de Paradis",
        "description": "Soin divin comprenant un massage thérapeutique et une réflexologie pour une relaxation totale."
      },
      "bookTreatment": "Réserver le Soin"
    },
    "categories": {
      "Body Massage": "Massage Corporel",
      "Specialty Treatments": "Soins Spécialisés",
      "Body Scrub and Mask": "Gommage et Masque Corporel",
      "Facial Treatment": "Soins du Visage",
      "Manicure and Pedicure": "Manucure et Pédicure",
      "Spa Packages": "Forfaits Spa"
    },
    "hero": {
      "subtitle": "Bienvenue au Spa Patal Kikian",
      "title": "Où le Corps se Repose, l'Âme Revient",
      "desc": "Notre spa prend soin de votre corps fatigué, tandis que la nature luxuriante de Sidemen embrasse votre cœur fatigué...",
      "btnScroll": "Voir le Menu Spa"
    },
    "sidebar": {
      "treatments": "Soins",
      "moreTreatments": "Plus de Soins"
    },
    "backToHome": "Retour à l'accueil"
  },
  "contact": {
    "hero": {
      "subtitle": "Contactez-nous",
      "title": "Contact",
      "desc": "Nous sommes là pour vous aider. Contactez-nous pour toute demande, réservation ou demande spéciale.",
      "scroll": "Nous Contacter"
    },
    "info": {
      "title": "Informations",
      "desc": "Vous avez une question ou besoin d'aide ? Notre équipe est toujours prête à vous aider à planifier votre séjour idéal à Sidemen.",
      "address": "Jl. Raya Sidemen, Sinduwati, Sidemen, Kabupaten Karangasem, Bali 80864"
    },
    "form": {
      "title": "Envoyez-nous un message",
      "name": "Votre Nom",
      "email": "Votre E-mail",
      "subject": "Sujet",
      "message": "Message",
      "btnSend": "Envoyer le Message",
      "btnSending": "Envoi en cours...",
      "success": "Merci ! Votre message a été envoyé avec succès.",
      "error": "Oups ! Quelque chose s'est mal passé. Veuillez réessayer plus tard."
    }
  },
  "faq": {
    "q1": {
      "question": "Quelles sont les heures d'arrivée et de départ ?",
      "answer": "L'enregistrement s'effectue à 14h00 et le départ à 12h00 (midi). Un enregistrement anticipé ou un départ tardif est sous réserve de disponibilité et peut entraîner des frais supplémentaires."
    },
    "q2": {
      "question": "Le petit-déjeuner est-il inclus dans le prix de la chambre ?",
      "answer": "Oui, un petit-déjeuner quotidien gratuit est inclus avec toutes nos réservations de villas."
    },
    "q3": {
      "question": "Proposez-vous des transferts aéroport ?",
      "answer": "Oui, nous proposons des services de transfert aéroport moyennant des frais supplémentaires. Veuillez nous contacter à l'avance pour organiser votre prise en charge."
    },
    "q4": {
      "question": "Patal Kikian est-il adapté aux familles ?",
      "answer": "Bien que nous accueillions des clients de tous âges, notre établissement est conçu comme une retraite tranquille. Les parents doivent surveiller les enfants à tout moment, en particulier près de la piscine."
    },
    "q5": {
      "question": "Prenez-vous en compte les restrictions alimentaires ?",
      "answer": "Absolument. Notre restaurant peut répondre à diverses exigences alimentaires, notamment végétariennes, végétaliennes et sans gluten. Veuillez nous informer de vos besoins avant votre arrivée."
    },
    "q6": {
      "question": "Le Wi-Fi est-il disponible à la villa ?",
      "answer": "Oui, une connexion Wi-Fi haut débit gratuite est disponible dans tout l'établissement, y compris dans toutes les chambres et les espaces publics."
    },
    "subtitle": "Informations",
    "title": "Questions Fréquentes",
    "stillHaveQuestions": "Vous avez encore des questions ?",
    "btnContact": "Contactez-nous"
  },
  "terms": {
    "usage": {
      "title": "Utilisation du site web",
      "p1": "Bienvenue sur notre site web. Si vous continuez à naviguer et à utiliser ce site, vous acceptez de respecter et d'être lié par les conditions d'utilisation suivantes, qui, avec notre politique de confidentialité, régissent la relation de Patal Kikian Villas avec vous en ce qui concerne ce site.",
      "p2": "Si vous n'êtes pas d'accord avec une partie de ces termes, veuillez ne pas utiliser notre site web. Le terme « Patal Kikian Villas » ou « nous » désigne le propriétaire du site web. Le terme « vous » désigne l'utilisateur de notre site.",
      "p3": "Le contenu de ce site web est uniquement destiné à votre information générale. Il est sujet à changement sans préavis. L'utilisation de toute information sur ce site est à vos risques et périls, pour lesquels nous ne serons pas responsables. Il est de votre responsabilité de vous assurer que les produits, services ou informations répondent à vos besoins spécifiques."
    },
    "booking": {
      "title": "Conditions de Réservation",
      "p1_bold": "Votre contrat avec Patal Kikian Villas:",
      "p1": "Ces conditions, ainsi que notre politique de confidentialité, constituent la base de votre contrat avec Patal Kikian Villas. En effectuant une réservation, la première personne nommée accepte, au nom de tous, qu'elle a lu ces termes et a l'autorité de s'y soumettre.",
      "p2_bold": "Paiement de votre réservation:",
      "p2": "Au moment de la réservation, il vous sera demandé de fournir des coordonnées de carte de crédit valides ou de payer un acompte par virement bancaire équivalant à une nuit. Les non-présentations (no-show) seront débitées sur la carte de crédit enregistrée.",
      "p3_bold": "Précision:",
      "p3": "Nous nous efforçons de garantir que toutes les informations et tous les prix sur notre site web sont exacts ; cependant, des erreurs peuvent parfois survenir et nous nous réservons le droit de corriger les prix et d'autres détails dans de telles circonstances."
    },
    "cancellation": {
      "title": "Politique d'Annulation",
      "p1_bold": "Tarifs Standards:",
      "p1": "Les annulations effectuées dans les 14 jours avant l'arrivée entraîneront des frais d'annulation d'une nuit. Les annulations dans les 7 jours, ou en cas de non-présentation, entraîneront des frais de 100 % de la valeur totale de la réservation.",
      "p2_bold": "Tarifs Non Remboursables:",
      "p2": "Les réservations effectuées à des tarifs non remboursables ne peuvent être ni annulées ni modifiées sans entraîner des frais de 100 %."
    },
    "copyright": {
      "title": "Avis de Droits d'Auteur",
      "p1": "Ce site web et son contenu sont la propriété de Patal Kikian Villas. Tous droits réservés. Toute redistribution ou reproduction de tout ou partie du contenu sous quelque forme que ce soit est interdite, à l'exception du téléchargement pour un usage personnel et non commercial uniquement."
    },
    "subtitle": "Légal",
    "title": "Termes et Conditions"
  },
  "privacy": {
    "policy": {
      "title": "Politique de Confidentialité",
      "p1": "Nous comprenons que nous fournir des informations personnelles et effectuer des achats en ligne implique une grande confiance de votre part ; nous prenons cela très au sérieux. Cette politique de confidentialité définit la façon dont Patal Kikian Villas utilise et protège toutes les informations que vous nous fournissez.",
      "p2": "Patal Kikian Villas s'engage à garantir la protection de votre vie privée. Si nous vous demandons de fournir certaines informations, soyez assuré qu'elles ne seront utilisées que conformément à cette déclaration.",
      "p3": "Nous pouvons modifier cette politique de temps à autre en mettant à jour cette page. Vous devez vérifier cette page périodiquement pour vous assurer que vous êtes satisfait des changements."
    },
    "collect": {
      "title": "Ce Que Nous Collectons",
      "p1": "Nous pouvons collecter les informations suivantes :",
      "l1": "Nom et coordonnées, y compris l'adresse e-mail",
      "l2": "Informations démographiques telles que le code postal, les préférences et les intérêts",
      "l3": "D'autres informations pertinentes pour les sondages clients et/ou les offres",
      "l4": "L'adresse IP de votre ordinateur"
    },
    "usage": {
      "title": "Ce Que Nous Faisons Avec Vos Informations",
      "p1": "Nous avons besoin de ces informations pour comprendre vos besoins et vous fournir un meilleur service, notamment pour les raisons suivantes :",
      "l1": "Tenue de dossiers internes.",
      "l2": "Nous pouvons utiliser ces informations pour améliorer nos produits et services.",
      "l3": "Nous pouvons envoyer périodiquement des e-mails promotionnels concernant de nouveaux produits ou offres à l'adresse e-mail que vous avez fournie.",
      "l4": "Nous pouvons utiliser les informations pour personnaliser le site web en fonction de vos intérêts.",
      "p2": "Vous pouvez vous désinscrire ou corriger les inexactitudes à tout moment en nous contactant par e-mail à info@patalkikianbali.com."
    },
    "security": {
      "title": "Sécurité & Informations Financières",
      "p1": "Nous nous engageons à garantir la sécurité de vos informations. Pour empêcher tout accès non autorisé, nous avons mis en place des procédures appropriées pour sauvegarder et sécuriser les informations collectées en ligne.",
      "p2_bold": "Informations Financières :",
      "p2": "Actuellement, nous ne stockons pas d'informations financières telles que des numéros de carte de crédit sur nos serveurs locaux. Les paiements sont traités par des passerelles tierces sécurisées."
    },
    "cookies": {
      "title": "Comment Nous Utilisons Les Cookies",
      "p1": "Un cookie est un petit fichier qui demande la permission d'être placé sur le disque dur de votre ordinateur. Les cookies permettent aux applications web de vous répondre en tant qu'individu. Vous pouvez choisir d'accepter ou de refuser les cookies via les paramètres de votre navigateur."
    },
    "subtitle": "Légal",
    "title": "Politique de Confidentialité"
  },
  "footer": {
    "explore": "Explorer",
    "information": "Informations",
    "contactTitle": "Contact",
    "contact": "Contact",
    "faq": "FAQ",
    "terms": "Termes et Conditions",
    "privacy": "Politique de Confidentialité",
    "whatsappUs": "Contactez-nous sur WhatsApp",
    "allRightsReserved": "Tous droits réservés.",
    "newsJournal": "Actualités",
    "translate": "Traduire",
    "desc": "Découvrez la vie sereine de Sidemen. Profitez de vues spectaculaires sur le mont Agung, de villas de luxe et d'une hospitalité chaleureuse parfaite pour les voyageurs en quête de détente à Bali.",
    "quickLinks": "Liens Rapides",
    "support": "Support"
  },
  "news": {
    "journal": "Journal",
    "latest": "Dernières Actualités & Histoires",
    "subtitle": "Restez informé des dernières nouvelles, histoires et événements autour de Patal Kikian et Sidemen.",
    "readNews": "Lire les Actualités",
    "allArticles": "Tous les Articles",
    "noArticles": "Aucun article trouvé dans cette catégorie.",
    "page": "Page",
    "of": "sur"
  },
  "newsSearch": {
    "searchBreadcrumb": "Recherche",
    "searchResults": "Résultats de Recherche",
    "searchArticles": "Rechercher des Articles",
    "resultsFound": "{{count}} résultats trouvés",
    "forQuery": " pour \"{{query}}\"",
    "placeholder": "Rechercher des articles...",
    "searchBtn": "Rechercher",
    "noResults": "Aucun article correspondant à \"{{query}}\".",
    "enterKeyword": "Entrez un mot-clé pour rechercher.",
    "backToNews": "Retour aux Actualités"
  },
  "newsCategory": {
    "category": "Catégorie",
    "articlesInCat": "articles dans cette catégorie",
    "noArticles": "Aucun article trouvé dans cette catégorie.",
    "backToNews": "Retour aux Actualités"
  },
  "newsDetail": {
    "tags": "Mots-clés",
    "exclusiveStay": "Séjour Exclusif",
    "promoDesc": "Vivez le Luxe Premium à Sidemen",
    "bookStay": "Réservez Votre Séjour",
    "reserveStay": "Réservez Votre Séjour",
    "villaRecs": "Recommandations de Villas",
    "recAccommodations": "Hébergements Recommandés",
    "readArticle": "Lire l'Article",
    "search": "Recherche",
    "searchPlaceholder": "Rechercher...",
    "go": "Aller",
    "categories": "Catégories",
    "popularPosts": "Articles Populaires",
    "bookNow": "Réserver",
    "notFound": "Article Introuvable",
    "notFoundDesc": "L'article que vous cherchez n'existe pas ou a été déplacé.",
    "backToNews": "Retour aux Actualités"
  }
}